/**
 * This hook is used for returning the formatted price of the product when no unit is selected
 */
import { useMemo } from 'react';
import maxBy from '@core/lodash/maxBy';
import minBy from '@core/lodash/minBy';
import { useContextParams } from '@core/params/context';
import { intlPrice } from '@core/shopping/utils/format';
/**
 *
 */
export const useProductPrice = (props) => {
    const { product, modifierFn } = props;
    const locale = useContextParams()?.lang;
    // [CS-5517] Filter out units that are not available. We assume they are available until
    // we are told otherwise.
    const availableUnits = useMemo(() => product?.product_units.filter((unit) => unit.available ?? true) || [], [product?.product_units]);
    // Formatted price of product (possibly min/max interval)
    const productPriceWithCurrency = useMemo(() => {
        if (!availableUnits.length) {
            return '';
        }
        const minUnit = minBy(availableUnits, 'unit_price');
        const maxUnit = maxBy(availableUnits, 'unit_price');
        const minUnitPrice = modifierFn
            ? modifierFn(minUnit?.unit_price)
            : minUnit?.unit_price;
        const maxUnitPrice = modifierFn
            ? modifierFn(maxUnit?.unit_price)
            : maxUnit?.unit_price;
        if (minUnitPrice === maxUnitPrice) {
            return (intlPrice(minUnitPrice, product?.product_currency, locale) ||
                minUnit?.unit_price_string);
        }
        return `${intlPrice(minUnitPrice, product?.product_currency, locale) ||
            minUnit?.unit_price_string} - ${intlPrice(maxUnitPrice, product?.product_currency, locale) ||
            maxUnit?.unit_price_string}`;
    }, [modifierFn, availableUnits, product, locale]);
    return productPriceWithCurrency;
};
